import React from 'react';
import { Checkbox, Input } from './styles';

/**
 * @param {string} [checked] - for checkbox checked state
 * @param {boolean} [disabled] - whether the checkbox is disabled
 * @param {(e: React.ChangeEvent<HTMLInputElement>) => void} [onChange] - callback when checkbox value changes
 * @param {(e: React.MouseEvent<HTMLInputElement>) => void} [onClick] - callback when checkbox is clicked
 * @param {string} [id] - unique identifier for the checkbox
 * @param {string} [name] - name attribute for the checkbox
 * @param {string} [ariaLabel] - accessibility label for screen readers
 * @param {boolean} [defaultChecked] - initial checked state (uncontrolled)
 * @param {'task-checkbox' | 'round-checkbox' | 'square-checkbox' | 'switch'} [checkboxType] - type of checkbox style
 */

interface Props {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  ariaLabel?: string;
  defaultChecked?: boolean;
  checkboxType?: 'task-checkbox' | 'round-checkbox' | 'square-checkbox' | 'switch';
}

const CheckboxInput: React.FC<Props> = ({
  checked,
  disabled = false,
  onChange,
  id,
  name,
  ariaLabel = 'Checkbox',
  defaultChecked = false,
  onClick,
  checkboxType = 'round-checkbox'
}) => {
  return (
    <Checkbox>
      <Input
        type='checkbox'
        aria-label={ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
        id={id}
        name={name}
        defaultChecked={defaultChecked}
        checkboxType={checkboxType}
      />
    </Checkbox>
  );
};

export default CheckboxInput;
